import axios from "axios";

const apiURL = "https://cryptogt-admin-backend.onrender.com/api/"; 
// const apiURL = "http://localhost:5000/api/"; 

export const loginMember = async (email, password) => {
  try {
    const response = await axios.post(`${apiURL}auth/login`, {
      email: email,
      password: password,
    });

    if (response.message === "Passwords do not match") {
      throw new Error("Invalid password");
    }

    if (response.status === 200) {
      return response.data;
    }
  } catch (error) {
    throw new Error("Invalid Email or Password!");
  }
};

